module.exports = __webpack_public_path__ + "img/people-41-min.4fb3fd33.png";